import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { ProductTransactionExportConfiguration } from './productTransactionExportConfiguration';

export class ProductTransactionExportConfigurationInput
  extends ProductTransactionExportConfiguration
  implements EntityInput<ProductTransactionExportConfiguration>
{
  forCreate(): CreateProductTransactionExportConfigurationInput {
    return CreateProductTransactionExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      CreateProductTransactionExportConfigurationInput,
    );
  }

  forUpdate(): UpdateProductTransactionExportConfigurationInput {
    return UpdateProductTransactionExportConfigurationInput.from(
      { ...this, mapping: Object.fromEntries(this.mapping) },
      UpdateProductTransactionExportConfigurationInput,
    );
  }

  forDelete(): DeleteProductTransactionExportConfigurationInput {
    return DeleteProductTransactionExportConfigurationInput.from(
      this,
      DeleteProductTransactionExportConfigurationInput,
    );
  }
}

export class CreateProductTransactionExportConfigurationInput extends forCreate(
  ProductTransactionExportConfiguration,
) {}

export class UpdateProductTransactionExportConfigurationInput extends forUpdate(
  ProductTransactionExportConfiguration,
) {}

export class DeleteProductTransactionExportConfigurationInput extends forDelete(
  ProductTransactionExportConfiguration,
) {}
